// extracted by mini-css-extract-plugin
export var option = "_2o-0";
export var optionSelected = "_2o-1 _2o-0";
export var optionUnselected = "_2o-2 _2o-0";
export var radioInner = "_2o-5";
export var radioOuter = "_2o-3";
export var radioOuterSelected = "_2o-4 _2o-3";